var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":_vm.modalId,"modal-class":"modal-loading","centered":"","hide-header":"","hide-footer":""},on:{"hidden":function($event){return _vm.onModalHidden()}}},[_c('div',{staticClass:"modal-loading-content"},[_vm._v(" Loading... ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }